import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './components/home/home.component';
import { I18nService } from '../commons/services/i18n.service';
import { HOME_I18N_ENTRIES } from './i18n/home-i18n-entries';
import { CommonsModule } from '../commons/commons.module';
import { ParadoxComponent } from './components/paradox/paradox.component';
import { ExperimentComponent } from './components/experiment/experiment.component';
import { WhatComponent } from './components/what/what.component';
import { HowComponent } from './components/how/how.component';
import { AllyComponent } from './components/ally/ally.component';
import { OpportunityComponent } from './components/opportunity/opportunity.component';
import { PartnersComponent } from './components/partners/partners.component';
import { CompanyContactFormComponent } from './components/dialogs/company-contact-form/company-contact-form.component';
import { SchoolContactFormComponent } from './components/dialogs/school-contact-form/school-contact-form.component';
import { SCHOOL_CONTACT_FORM_I18N_ENTRIES } from './i18n/school-contact-form-i18n-entries';
import { GrantsComponent } from './components/grants/grants.component';
import { GrantEmploymentDialogComponent } from './components/dialogs/grant-employment-dialog/grant-employment-dialog.component';


@NgModule({
  declarations: [
    HomeComponent,
    ParadoxComponent,
    ExperimentComponent,
    WhatComponent,
    HowComponent,
    AllyComponent,
    OpportunityComponent,
    PartnersComponent,
    CompanyContactFormComponent,
    SchoolContactFormComponent,
    GrantsComponent,
    GrantEmploymentDialogComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    CommonsModule
  ]
})
export class HomeModule {
  constructor(private i18nService: I18nService) {
    i18nService.addI18nEntriesObject(HOME_I18N_ENTRIES);
    i18nService.addI18nEntriesObject(SCHOOL_CONTACT_FORM_I18N_ENTRIES);
  }
}
